var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.25C14.7949 16.25 16.25 14.7949 16.25 13C16.25 11.2051 14.7949 9.75 13 9.75C11.2051 9.75 9.75 11.2051 9.75 13C9.75 14.7949 11.2051 16.25 13 16.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 4.33341H18.2325L16.8891 2.87091C16.4883 2.42675 15.9033 2.16675 15.2966 2.16675H10.7033C10.0966 2.16675 9.51162 2.42675 9.09996 2.87091L7.76746 4.33341H4.33329C3.14163 4.33341 2.16663 5.30841 2.16663 6.50008V19.5001C2.16663 20.6917 3.14163 21.6667 4.33329 21.6667H21.6666C22.8583 21.6667 23.8333 20.6917 23.8333 19.5001V6.50008C23.8333 5.30841 22.8583 4.33341 21.6666 4.33341ZM13 18.4167C10.01 18.4167 7.58329 15.9901 7.58329 13.0001C7.58329 10.0101 10.01 7.58341 13 7.58341C15.99 7.58341 18.4166 10.0101 18.4166 13.0001C18.4166 15.9901 15.99 18.4167 13 18.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a2edcb3994ffd373597a1db6659bca2a.svg";
export { ForwardRef as ReactComponent };